/** Shared competition list and user preference helpers (frontend). */
export const PREFERRED_COMPETITION_STORAGE_KEY = "predictions_preferred_competition";

export const PREDICTION_COMPETITION_IDS = [
  "premier_league",
  "laliga",
  "bundesliga",
  "serie_a",
  "ucl",
  "wildcard",
  "world_cup",
];

export const COMPETITION_OPTIONS = [
  { id: "premier_league", label: "Premier League" },
  { id: "laliga", label: "LaLiga" },
  { id: "bundesliga", label: "Bundesliga" },
  { id: "serie_a", label: "Serie A" },
  { id: "world_cup", label: "World Cup" },
  { id: "ucl", label: "Champions League" },
  { id: "wildcard", label: "Wildcard" },
];

export function getDefaultEnabledCompetitionIds() {
  return [...PREDICTION_COMPETITION_IDS];
}

export function getEnabledCompetitionIds(user) {
  const raw = user?.enabled_competitions;
  if (raw === null || raw === undefined) {
    return getDefaultEnabledCompetitionIds();
  }
  if (!Array.isArray(raw) || raw.length === 0) {
    return getDefaultEnabledCompetitionIds();
  }
  const seen = new Set();
  const ids = [];
  for (const item of raw) {
    const id = String(item || "").trim().toLowerCase();
    if (!PREDICTION_COMPETITION_IDS.includes(id) || seen.has(id)) continue;
    seen.add(id);
    ids.push(id);
  }
  return ids.length > 0 ? ids : ["premier_league"];
}

export function filterCompetitionsByEnabled(competitions, enabledIds) {
  const set = new Set(enabledIds);
  return competitions.filter((c) => set.has(c.id ?? c.key));
}

export function pickInitialCompetitionId(enabledIds, preferredId) {
  if (preferredId && enabledIds.includes(preferredId)) return preferredId;
  if (enabledIds.includes("premier_league")) return "premier_league";
  return enabledIds[0] || "premier_league";
}

export function getStoredPreferredCompetitionId() {
  try {
    const raw = localStorage.getItem(PREFERRED_COMPETITION_STORAGE_KEY);
    if (raw && PREDICTION_COMPETITION_IDS.includes(raw)) return raw;
  } catch (_) {
    /* ignore */
  }
  return "premier_league";
}

export function setStoredPreferredCompetitionId(id) {
  if (!PREDICTION_COMPETITION_IDS.includes(id)) return;
  try {
    localStorage.setItem(PREFERRED_COMPETITION_STORAGE_KEY, id);
  } catch (_) {
    /* ignore */
  }
}
